import React, { useEffect, useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PlayIcon } from '@heroicons/react/24/solid'
import { ModalWithMediasProps } from './ModalWithMedia'
import { fetchYouTubeVideoThumbnail, isPortaitPicture } from './utils'
import { YoutubeVideo } from './YoutubeVideo'
import { useWindowDimensions } from '../../../Utils/useScreenSize'

interface MediaProps extends ModalWithMediasProps {
  isIFrame?: boolean
  forceHeight?: boolean
}

export const Media = ({
  media,
  name,
  video,
  youTubeApiKey,
  isIFrame = false,
  forceHeight = false,
}: MediaProps) => {
  if (!media) {
    console.warn(`No media provided for ${name}`)
    return null
  }
  const [thumbnail, setThumbnail] = useState<string | null>(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const {
    dimensions: { width: windowWidth },
    setDimensions,
  } = useWindowDimensions({})

  useEffect(() => {
    const fetchThumbnail = async () => {
      if (typeof media === 'string' && video && youTubeApiKey) {
        const url = await fetchYouTubeVideoThumbnail(media, youTubeApiKey)
        setThumbnail(url)
      }
    }
    fetchThumbnail()
    setDimensions({ width: window.innerWidth, height: window.innerHeight })
    setIsLoaded(true)
  }, [media, video])

  if (typeof media === 'object' && 'images' in media) {
    return (
      <GatsbyImage
        image={media}
        alt={`image de ${name}`}
        className="w-full h-full rounded-xl no-scrollbar"
        imgStyle={{
          // eslint-disable-next-line no-nested-ternary
          height: forceHeight
            ? '100%'
            : isPortaitPicture(media)
              ? 'auto'
              : '100%',
          borderRadius: '0.75rem',
          overflowY: 'visible',
        }}
        loading="eager"
        style={{ overflowY: 'visible', borderRadius: '0.75rem' }}
      />
    )
  }

  if (typeof media === 'string' && video && youTubeApiKey) {
    if (isIFrame) {
      return (
        <>
          <div id="video-container" className="hidden w-full h-full xl:block">
            <YoutubeVideo
              title={`vidéo de ${name}`}
              url={media as unknown as string}
              height={700}
              width={1024}
            />
          </div>
          <div
            id="video-container"
            className="hidden w-full h-full lg:block xl:hidden"
          >
            <YoutubeVideo
              title={`vidéo de ${name}`}
              url={media as unknown as string}
              height={700}
              width={824}
            />
          </div>
          <div
            id="video-container"
            className="hidden w-full h-full md:block lg:hidden"
          >
            <YoutubeVideo
              title={`vidéo de ${name}`}
              url={media as unknown as string}
              height={500}
              width={750}
            />
          </div>
          <div id="video-container" className="w-full h-full md:hidden">
            <YoutubeVideo
              title={`vidéo de ${name}`}
              url={media as unknown as string}
              height={250}
              width={windowWidth - 15}
            />
          </div>
        </>
      )
    }

    return (
      <div className="relative">
        <img
          src={thumbnail ?? media}
          alt={`vidéo de ${name}`}
          className="w-full h-full rounded-xl"
        />

        {isLoaded && (
          <div className="absolute inset-0 flex items-center justify-center">
            <PlayIcon className="w-12 h-12 text-white" />
          </div>
        )}
      </div>
    )
  }

  return (
    <img
      src={media}
      alt={`média de ${name}`}
      className="w-full h-full rounded-xl no-scrollbar"
    />
  )
}
